import type { DueJobRow } from './dueJobTypes';

/** Build `/pms/pms-work-orders/new?...` prefilled from a due-board job. */
export function buildCreateWorkOrderPath(job: DueJobRow): string | null {
  const vesselId = job.equipment?.vesselId ?? job.equipment?.vessel?.id;
  const equipmentId = job.equipment?.id;
  if (vesselId == null || equipmentId == null) return null;

  const eqCode = job.equipment?.equipmentCode ?? job.equipment?.code ?? '';
  const eqName = job.equipment?.name ?? '';
  const jobCode = job.jobCode ?? '';
  const jobTitle = (job.title ?? jobCode) || `Job #${job.id}`;
  const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const woNumber = `WO-${jobCode || job.id}-${stamp}`;

  const params = new URLSearchParams();
  params.set('fromDueJob', '1');
  params.set('vesselId', String(vesselId));
  params.set('equipmentId', String(equipmentId));
  params.set('maintenanceJobId', String(job.id));
  if (job.primarySchedule?.id != null) {
    params.set('maintenanceScheduleId', String(job.primarySchedule.id));
  }
  params.set('workOrderNumber', woNumber);
  params.set('title', jobTitle);
  if (job.description) params.set('description', job.description);
  if (job.priority != null) params.set('priority', String(job.priority));
  if (job.responsibleRankId != null) params.set('assignedRankId', String(job.responsibleRankId));
  params.set('snapshotEquipmentCode', eqCode || `EQ-${equipmentId}`);
  params.set('snapshotEquipmentName', eqName || `Equipment #${equipmentId}`);
  if (job.equipment?.serialNumber) params.set('snapshotEquipmentSerial', job.equipment.serialNumber);
  if (jobCode) params.set('snapshotJobCode', jobCode);
  params.set('snapshotJobTitle', jobTitle);

  return `/pms/pms-work-orders/new?${params.toString()}`;
}
